import { css } from '@/styled-system/css';

export const getListingCardCallButtonStyles = () =>
  css({
    flex: '1',
    paddingTop: '0',
    paddingRight: '0',
    paddingBottom: '0',
    paddingLeft: '0',
    display: 'none !important',
    '@media (max-width: 767px)': {
      display: 'block !important',
    },
  });

export const callButtonAnchorStyles = css({
  display: 'flex !important',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  textDecoration: 'none',
});
